import QaReviewsPage from '../pages/admin/qa-reviews/qa-reviews-page'
export default QaReviewsPage
